import { Dropdown, IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import type { ESavedSearchActions } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/types/enums";

import { DROPDOWN_WIDTH, SAVED_SEARCH_SUBMIT_DD_ANCHOR } from "./const";
import { StyledDDContainer, StyledDropdownItem } from "./styles";

interface ISavedSearchActionsDropdownProps {
    isUpdateEnabled?: boolean;
    onSelect: (action: ESavedSearchActions) => void;
}

const SavedSearchActionsDropdown = ({ isUpdateEnabled = true, onSelect }: ISavedSearchActionsDropdownProps) => {
    const handleSelect = (item: { id: ESavedSearchActions }) => {
        onSelect(item.id);
    };

    return (
        <StyledDDContainer id={SAVED_SEARCH_SUBMIT_DD_ANCHOR}>
            <Dropdown
                width={DROPDOWN_WIDTH}
                onClick={handleSelect}
                dropdownPopupPlacement="bottom-right"
                appendTo={`#${SAVED_SEARCH_SUBMIT_DD_ANCHOR}`}
            >
                {[
                    <IconButton
                        type="primary"
                        iconName="diskette-shape"
                        dataAutomation="filters-panel.save-search-button"
                    >
                        {translate("si.lead_gen_filters.button.save-filters")}
                    </IconButton>,
                    isUpdateEnabled ? (
                        <StyledDropdownItem
                            key="item-update"
                            id="saved-search-update-action"
                        >
                            {translate("si.lead_gen_filters.button.update_current")}
                        </StyledDropdownItem>
                    ) : null,
                    <StyledDropdownItem
                        key="item-save-as-new"
                        id="saved-search-save-action"
                    >
                        {translate("si.lead_gen_filters.button.save_as_new")}
                    </StyledDropdownItem>,
                ].filter(Boolean)}
            </Dropdown>
        </StyledDDContainer>
    );
};

export default SavedSearchActionsDropdown;
